import client from "./client";

const tutorApi = {
  // Students
  listStudents() {
    return client.get("/tutor/students").then((r) => r.data);
  },
  createStudent(body) {
    return client.post("/tutor/students", body).then((r) => r.data);
  },
  updateStudent(id, body) {
    return client.patch(`/tutor/students/${id}`, body).then((r) => r.data);
  },
  deleteStudent(id) {
    return client.delete(`/tutor/students/${id}`).then((r) => r.data);
  },

  // Classes
  listClasses(params = {}) {
    return client.get("/tutor/classes", { params }).then((r) => r.data);
  },
  logClass(studentId, body) {
    return client.post(`/tutor/students/${studentId}/classes`, body).then((r) => r.data);
  },
  addFee(studentId, body) {
    return client.post(`/tutor/students/${studentId}/add-fee`, body).then((r) => r.data);
  },

  // Tasks
  addTask(studentId, body) {
    return client.post(`/tutor/students/${studentId}/tasks`, body).then((r) => r.data);
  },

  // Homework
  listHomework() {
    return client.get("/tutor/homework").then((r) => r.data);
  },
  createHomework(body) {
    return client.post("/tutor/homework", body).then((r) => r.data);
  },

  // Attendance
  markAttendance(body) {
    return client.post("/tutor/attendance", body).then((r) => r.data);
  },

  // Reminders
  listReminders() {
    return client.get("/tutor/reminders").then((r) => r.data);
  },
  createReminder(body) {
    return client.post("/tutor/reminders", body).then((r) => r.data);
  },
  deleteReminder(id) {
    return client.delete(`/tutor/reminders/${id}`).then((r) => r.data);
  },
};

export default tutorApi;
